export default "__VITE_ASSET__BB1RSEEp__"